import React from 'react'
import { render } from 'react-dom'
import ShowferPlayer from './index'

export default function renderShowferPlayer (container, props) {
  render(<ShowferPlayer {...props} />, container);
}